
import React, { useEffect, useRef, useState } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import EditUser from "../views/EditUser";
import Rewards from "../views/Rewards";
import Notification from "../views/Notification";

// core components
import AdminNavbar from "../components/Navbars/AdminNavbar.js";
import Footer from "../components/Footer/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";
import FixedPlugin from "../components/FixedPlugin/FixedPlugin.js";

import routes from "../routes.js";

import logo from "assets/img/logo.png";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";

var ps;

function Admin({ token, setToken }) {
    const location = useLocation();
    const mainPanelRef = useRef(null);
    const [sidebarOpened, setsidebarOpened] = useState(
        document.documentElement.className.indexOf("nav-open") !== -1
    );

    useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            document.documentElement.className += " perfect-scrollbar-on";
            document.documentElement.classList.remove("perfect-scrollbar-off");
            ps = new PerfectScrollbar(mainPanelRef.current, {
                suppressScrollX: true
            });
            let tables = document.querySelectorAll(".table-responsive");
            for (let i = 0; i < tables.length; i++) {
                ps = new PerfectScrollbar(tables[i]);
            }
        }
        // Specify how to clean up after this effect:
        return function cleanup() {
            if (navigator.platform.indexOf("Win") > -1) {
                ps.destroy();
                document.documentElement.classList.add("perfect-scrollbar-off");
                document.documentElement.classList.remove("perfect-scrollbar-on");
            }
        };
    });
    useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            let tables = document.querySelectorAll(".table-responsive");
            for (let i = 0; i < tables.length; i++) {
                ps = new PerfectScrollbar(tables[i]);
            }
        }
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        if (mainPanelRef.current) {
            mainPanelRef.current.scrollTop = 0;
        }
    }, [location]);

    useEffect(() => {
        console.log('Get admin data')
        const myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);

        const requestOptions = {
            method: 'GET',
            headers: myHeaders
        };

        fetch(process.env.REACT_APP_BASE_URL + "info", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    console.log(json)
                    if (result.ok) {

                    }
                    else {
                        if (json.message === "Unauthorized" || json.message === "Signature has expired") setToken(null)
                    }
                }
            )
    }, [setToken, token]);

    // this function opens and closes the sidebar on small devices
    const toggleSidebar = () => {
        document.documentElement.classList.toggle("nav-open");
        setsidebarOpened(!sidebarOpened);
    };
    const getSidebarRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/admin") {
                return (
                    <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };
    const getBrandText = (path) => {
        if (location.pathname.indexOf('/edit-user') !== -1) return "Edit User"
        if (location.pathname.indexOf('/maintenance-codes') !== -1) return "Rewards - Maintenance/Codes"
        if (location.pathname.indexOf('/rewards') !== -1) return "Rewards - Application/Use"
        if (location.pathname.indexOf('/notification/log') !== -1) return "Notification - Log"
        if (location.pathname.indexOf('/notification/report') !== -1) return "Notification - Report"
        if (location.pathname.indexOf('/notification') !== -1) return "Notification - Config"

        for (let i = 0; i < routes.length; i++) {
            if (location.pathname.indexOf(routes[i].path) !== -1) {
                return routes[i].name;
            }
        }
        return "Brand";
    };
    return (
        <BackgroundColorContext.Consumer>
            {({ color, changeColor }) => (
                <React.Fragment>
                    <div className="wrapper">
                        <Sidebar
                            routes={routes}
                            logo={{
                                outterLink: "/",
                                text: "The Movie House",
                                imgSrc: logo
                            }}
                            toggleSidebar={toggleSidebar}
                        />
                        <div className="main-panel" ref={mainPanelRef} data={color}>
                            <AdminNavbar
                                brandText={getBrandText(location.pathname)}
                                toggleSidebar={toggleSidebar}
                                sidebarOpened={sidebarOpened}
                                setToken={setToken}
                            />
                            <Switch>
                                <Route
                                    path="/rewards/:request_type"
                                    component={Rewards}
                                />
                                <Route
                                    path="/notification/:request_type"
                                    component={Notification}
                                />
                                <Route
                                    path="/edit-user/:userId"
                                    component={EditUser}
                                />
                                {getSidebarRoutes(routes)}
                                <Redirect from="*" to="dashboard" />
                            </Switch>
                            <Footer fluid />
                        </div>
                    </div>
                    <FixedPlugin bgColor={color} handleBgClick={changeColor} />
                </React.Fragment>
            )}
        </BackgroundColorContext.Consumer>
    );
}

export default Admin;
